import { List, Map } from 'immutable';
import createSelector from '../../utils/reselect';

export const getInspectionDetailById = (state: any) => {
    const { inspectionDetail } = state;
    return inspectionDetail || Map();
};

export const getInspectionDetailLoading = createSelector(getInspectionDetailById, (state) => {
    return state.getIn(['inspectionDetail', 'loading']);
});

export const getInspectionDetail = createSelector(getInspectionDetailById, (state) => {
    return state.getIn(['inspectionDetail', 'data']) || Map();
});

export const getInspectionEditForm = createSelector(getInspectionDetailById, (state) => {
    return state.getIn(['inspectionEditForm', 'data']) || Map();
});

export const getUpdateInspectionLoader = createSelector(getInspectionDetailById, (state) => {
    return state.getIn(['inspectionData', 'loading']);
});

export const getAddInspectionCommentLoader = createSelector(getInspectionDetailById, (state) => {
    return state.getIn(['inspectionComment', 'loading']);
});

export const getInspectionCommentList = createSelector(getInspectionDetailById, (state) => {
    return state.getIn(['inspectionComment', 'data']) || List();
});
/*
 * getInspectionCommentListLoadingStatus will return InspectionComment list api loader status
 */
export const getInspectionCommentListLoadingStatus = createSelector(getInspectionDetailById, (state) => {
    return state.getIn(['inspectionComment', 'loading']);
});

export const getInspectionViolationsLoadingStatus = createSelector(getInspectionDetailById, (state) => {
    return state.getIn(['inspectionViolations', 'loading']);
});

/*
 * getViolationListAssociatedWithInspection will return application violation list
 */
export const getViolationListAssociatedWithInspection = createSelector(getInspectionDetailById, (state) => {
    return state.getIn(['inspectionViolations', 'data']) || List();
});

/*
 * load more boolean to see if there are more record for violations associated with inspections on server
 */
export const getLoadMoreViolationAssociatedToInspection = createSelector(getInspectionDetailById, (state) => {
    return state.getIn(['inspectionViolations', 'loadMore']);
});

export const getLoadMoreInspectionCommentList = createSelector(getInspectionDetailById, (state) => {
    return state.getIn(['inspectionComment', 'loadMore']);
});

export const getAddInspectionForm = createSelector(getInspectionDetailById, (state) => {
    return state.getIn(['addInspectionForm', 'data']) || Map();
});

export const isAddInspectionFormLoading = createSelector(getInspectionDetailById, (state) => {
    return state.getIn(['addInspectionForm', 'loading']);
});
